import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import { TitleSideLink } from "../../Share";
import { useState } from "react";
import redArrow from "../../assets/images/icons/red_arrow.svg";
import logoutIcon from "../../assets/images/icons/logout.svg";
import LogoutModal from "../../Layout/components/LogoutModal";

function SettingLayout() {
  const sidebar = [
    { link: "/setting/notifications_setting", label: "notifications_setting" },
    { link: "/setting/account_setting", label: "account_setting" },
    { link: "/setting/help_center", label: "help_center" },
    { link: "/setting/about_dome_care", label: "about_dome_care" },
  ];
  const { t } = useTranslation();
  const location = useLocation();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const handleLogoutModalClose = () => setIsLogoutModalOpen(false);
  const handleLogoutModalOpen = () => setIsLogoutModalOpen(true);

  const getCurrentLabel = () => {
    const currentItem = sidebar.find((item) =>
      location.pathname.includes(item.link),
    );
    return currentItem ? currentItem.label : "";
  };

  return (
    <div className="box flex h-full gap-4 max-md:flex-col">
      <div className="flex flex-col gap-2 md:w-96">
        {sidebar.map((e, i) => (
          <TitleSideLink key={i} label={e.label} to={e.link} />
        ))}
        <div
          className="my-auto flex cursor-pointer items-center justify-between p-3 text-error"
          onClick={handleLogoutModalOpen}
        >
          <div className="flex items-center gap-2 text-error">
            <img src={logoutIcon} alt="logoutIcon" />
            <p>{t("logout")}</p>
          </div>
          <img src={redArrow} alt="redArrow" className="rtl:rotate-180" />
        </div>
      </div>
      <div className="border bg-radio md:h-full" /> 
      <div className="flex h-full w-full flex-col gap-6 max-md:max-h-full max-md:overflow-y-scroll">
        <h2 className="font-bold max-md:flex-shrink-0">
          {t(getCurrentLabel())}
        </h2>
        <div className="overflow-y-auto max-md:h-full max-md:overflow-y-visible">
          <Outlet />
        </div>
      </div>

      <LogoutModal
        isOpen={isLogoutModalOpen}
        onClose={handleLogoutModalClose}
      />
    </div>
  );
}

export default SettingLayout;
